import { useEffect, useState } from "react";
import { Space } from "../common";
import { CiSearch } from "react-icons/ci";
import { useLocation, useNavigate } from "react-router-dom";
import { setSearchKey } from "../../redux/slices/filter/filterSlice";
import { useSelector } from "react-redux";
import { dispatch } from "../../redux/store";

const SearchBar = () => {
  const navigate = useNavigate();
  const pathName = useLocation().pathname;
  const [search, setSearch] = useState("");
  console.log("🚀 ~ SearchBar ~ search:", search);
  const { searchKey } = useSelector((state: any) => state.filter);

  function handleSearch(searchKey: any) {
    console.log("🚀 ~ handleSearch ~ searchKey:", searchKey);
    setSearch(searchKey);
    dispatch(setSearchKey(searchKey));
    navigate(`/products?search=${searchKey}`);
  }

  // console.log(searchKey);

  useEffect(() => {
    if (pathName !== "/products") {
      dispatch(setSearchKey(undefined));
    }
  });
  return (
    <div className="flex-grow lg:max-w-[320px]">
      <div className="hidden shadow-custom border-[1px] rounded-md lg:flex lg:gap-2 min-w-fit flex-grow">
        <div className=" w-full rounded-[5px] rounded-br-[5px] pl-[16px] bg-white">
          <div className="flex">
            <div className=" rounded-r-[5px] pr-3 flex items-center justify-center">
              <CiSearch color="#333333" size={24} className="h-full" />
            </div>
            <input
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  // @ts-expect-error
                  handleSearch(e.target.value);
                }
              }}
              onChange={(e) => setSearch(e.target.value)}
              type="text"
              defaultValue={searchKey}
              placeholder="Search Products"
              className="bg-white border-none placeholder:text-[#768576] outline-none py-[11px] text-[14px] grow font-normal text-[#000] font-[Source Sans Pro] lg:min-w-[300px] xl:min-w-[400px]"
            />
            <div
              onClick={() => handleSearch(search)}
              className="bg-[#00B207] text-white hover:opacity-70 text-xs font- rounded-r-[5px] cursor-pointer w-[76px] flex items-center justify-center"
            >
              Search
            </div>
          </div>
        </div>
      </div>
      <div className="lg:hidden flex py-2">
        <div className="bg-white border-[1px] w-full h-10 flex rounded-md overflow-hidden">
          <div className="h-full flex-grow">
            <input
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  // @ts-expect-error
                  handleSearch(e.target.value);
                }
              }}
              onChange={(e) => setSearch(e.target.value)}
              type="text"
              className="w-full h-full bg-white px-3 outline-none"
              placeholder="Search Products"
            />
          </div>
          <div
            onClick={() => handleSearch(search)}
            className="h-full w-12 flex text-[#4ECB71] items-center justify-center cursor-pointer active:bg-[#4ECB71] active:text-white transition-colors duration-200"
          >
            <CiSearch size={24} className="h-full" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default SearchBar;
